$(document).ready(function () {
  const atc_flow = $(".product-selector_atc").attr("data-atc-flow");
  if (atc_flow == 'checkout') { window.upcartShouldOpenOnAddToCartBackgroundNetworkCall = false; }

  $(".product-selector_block").click(function () {
    $(this)
      .closest(".product-selector_outer")
      .find(".product-selector_block")
      .removeClass("active");
    $(this).addClass("active");

    var index = $(this).attr('data-index');
    $('.product_atc-sub-line.change').addClass('hided');
    $('.product_atc-sub-line.change[data-index="' + index + '"]').removeClass('hided');
  });

  $(".pp_var_autoship").click(function () {
    $(this).toggleClass("disabled");
    if ($(".pp_var_autoship").hasClass("disabled")) {
      $('.product-selector_outer[data="sub"]').removeClass("active_block");
      $('.product-selector_outer[data="otp"]').addClass("active_block");
    } else {
      $('.product-selector_outer[data="sub"]').addClass("active_block");
      $('.product-selector_outer[data="otp"]').removeClass("active_block");
    }
  });

  $(".product-selector_atc").click(function () {
    if ($(this).attr("data-mode-champs") == "true") {
      var newUrl = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-champs-url");

      window.location.href = newUrl;
    } else {
      var currentId = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-id");
      var mode = $(".product-selector_outer.active_block").attr("data");
      var currentSellingPlan = $(".product-selector_outer.active_block")
        .find(".product-selector_block.active")
        .attr("data-selling-plan");

      const data = {
        id: currentId,
        quantity: 1,
        selling_plan: mode == "sub" ? currentSellingPlan : undefined,
      };

      jQuery.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function () {
          if (atc_flow == 'checkout') {
            window.location.href = '/checkout'
          } else {
            if ($('#cart-drawer-kandy').length) {
              window.cart_open && window.cart_open();
              window.cart_build && window.cart_build();
            } else {
              // window.location.href = '/cart';
            }
          }
        },
        error: function () {
          alert("Error adding item to the cart.");
        },
      });
    }
  });
});
